var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUk = function SvgUk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 0H0v16h24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7002C",
    d: "M13.5 0h-3v6.499H0v2.997h10.5v6.499h3v-6.5H24V6.5H13.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0853AD",
    d: "M14.61 10.78 24 15.995V14.52l-6.74-3.74z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M14.61 10.78 24 15.995V14.52l-6.74-3.74z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7002C",
    d: "M14.61 10.78 24 15.995V14.52l-6.74-3.74zM6.734 10.78 0 14.52v1.475l9.39-5.215z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0853AD",
    d: "M9.39 5.215 0 0v1.475l6.734 3.74z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M9.39 5.215 0 0v1.475l6.734 3.74z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7002C",
    d: "M9.39 5.215 0 0v1.475l6.734 3.74z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#001E5E",
    d: "M18.458 10.78 24 13.86v-3.08zM21.498 15.995l-6.888-3.827v3.827zM4.237 10.78 0 13.132V10.78zM9.39 11.44v4.555H1.192zM5.542 5.215 0 2.135v3.08zM2.502 0 9.39 3.827V0zM19.763 5.215 24 2.863v2.352zM14.61 4.55V0h8.193z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7002C",
    d: "M17.26 5.215 24 1.475V0l-9.39 5.215z"
  })));
};
export default SvgUk;